import angular from 'angular';
//import ngResource from 'angular-resource';
import angularFileUpload from 'angular-file-upload';
import uiBootstrap from 'angular-ui-bootstrap';

try { angular.module("ngResource") } catch(err) { require('angular-resource') }

const avatarService = angular.module('ttb.services.avatar.service', [
    'ngResource',
    uiBootstrap,
    'angularFileUpload',
])
    .factory('AvatarResourceService', ['$resource', function ($resource) {
        return $resource('/api/avatar/', {}, {
            save: { method: 'PUT' }
        });
    }])
    .factory('AvatarService', ['$uibModal',
        function ($uibModal) {

            function openModal({ id, url, type, cb }) {
                $uibModal.open({
                    backdrop: 'static',
                    animation: false,
                    template: `
                        <div class="modal-header">
                            <button type="button" class="close" ng-click="dismiss()">×</button>
                            <h4 class="modal-title">
                                Edit Avatar
                            </h4>
                        </div>
                        <div class="modal-body clearfix">
                            <img class={{imageSelectorClass}} ng-if="!fileTempId && url" ng-src="{{ id ? (url + '&size=o') : null }}" ng-style="{opacity: isDeleted ? '0.5' : '1'}" width="300"/>
                            <img class={{imageSelectorClass}} ng-if="fileTempId" ng-src="/system/GetTempFileContent?id={{fileTempId}}" ng-style="{opacity: isDeleted ?'0.5' : '1'}" width="300"/>
                            <label class="pull-right">
                                <input type="file" id="avatar-select-file" nv-file-select uploader="uploader" accept="image/*" style="display: none;" />
                                <button class="btn btn-primary waves-effect waves-light w-md" onclick="document.getElementById('avatar-select-file').click()">Choose a file</button>
                            </label>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-warning waves-effect waves-light pull-left" ng-click="delete()" ng-if="!isDeleted" ng-disabled="!url">Delete</button>
                            <button type="button" class="btn btn-info waves-effect waves-light pull-left" ng-click="rollBack()" ng-if="isDeleted" ng-disabled="!url">Rollback</button>

                            <button type="button" class="btn btn-default waves-effect waves-light" ng-click="dismiss()">Close</button>
                            <button type="button" class="btn btn-primary waves-effect waves-light" ng-click="save()" ng-disabled="!fileTempId && !isDeleted">Save</button>
                        </div>
                        `,
                    controller: ['$scope', 'AvatarResourceService', 'FileUploader', function AvatarController($scope, AvatarResourceService, FileUploader) {

                        $scope.imageSelectorClass = "avatarImg";

                        $scope.id = id;
                        $scope.url = url;
                        $scope.type = type;

                        $scope.isDeleted = false;                        
                        $scope.fileTempId = null;


                        $scope.uploader = new FileUploader({ url: '/system/fileupload' });
                        $scope.uploader.onAfterAddingFile = function (file) {
                            if ($scope.uploader.isHTML5 && file.file.size / (1024 * 1024) > 10) {
                                alert("Please chose file less than 10 mb");
                                file.remove();
                            } else {
                                $scope.uploader.uploadAll();
                                $scope.isDeleted = false;
                            }
                        };
                        $scope.uploader.onErrorItem = function (file, response, status) {
                            alert(status);
                        };
                        $scope.uploader.onSuccessItem = function (file, response) {
                            $scope.fileTempId = response.fileId;
                            initImageSelection();
                        };

                        $scope.dismiss = function () {
                            $scope.$dismiss();
                            $scope.isDeleted = false;
                            if ($scope.imageSelection) $scope.imageSelection.cancelSelection();
                        };
                        $scope.save = function () {
                            var avatar = {
                                id: $scope.fileTempId,
                                deleted: $scope.isDeleted,
                                [type]: id,
                                avatarSelection: $scope.selection
                            };
                           

                            AvatarResourceService.save(null, avatar).$promise.then(function (r) {
                                if ($scope.imageSelection) $scope.imageSelection.cancelSelection();
                                if (cb) cb({ url: r.url });
                                $scope.$dismiss();
                                //$("#user-avatar")[0].src = r.url;
                            });
                        };
                        $scope.delete = function () {
                            $scope.isDeleted = true;
                        }
                        $scope.rollBack = function () {
                            $scope.isDeleted = false;
                        }
                        
                        function initImageSelection(){

                            setTimeout(function () {

                                let profileImage = $("." +  $scope.imageSelectorClass);
                                let minSize = profileImage.width() > profileImage.height() ? profileImage.height() : profileImage.width();
                                minSize = minSize || minSize === 0 ? 150 : minSize;
                                console.log(minSize);
                                $scope.imageSelection = profileImage.imgAreaSelect({
                                  instance: true,
                                  handles: true,
                                  aspectRatio: '3:3',
                                  x1: 0, y1: 0,
                                  x2: minSize, y2: minSize,
                                  onSelectEnd: function(img, selection){

                                    selection.x1 = Math.floor(selection.x1 * (img.naturalWidth / img.width));
                                    selection.y1 = Math.floor(selection.y1 * (img.naturalHeight / img.height));
                                    selection.width = Math.floor(selection.width * (img.naturalWidth / img.width));
                                    selection.height = Math.floor(selection.height * (img.naturalHeight / img.height));

                                      $scope.selection = selection;
                                  }
                                });
                            }, 100);
                        }
                    }]
                }).result.catch(e => {});
            }

          
            return {
                openModal,
            };
        }])
    .name;

export default avatarService;


// WEBPACK FOOTER //
// ../services/avatar.service.js